export default __webpack_public_path__ + "static/IBMPlexSans-ExtraLight-Latin1-a8a0c576e782f2130f3b6718578a792f.woff";